import React, { useEffect, useRef, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import GeoJSON from 'ol/format/GeoJSON';
import WKB from 'ol/format/WKB';
import PropTypes from 'prop-types';
import ParcelleTable from '@/components/Tables/ParcelleTable';
import { validatedParcelLayer } from '@/ol/layers';
import { proj2154, proj3857, proj4326 } from '@/ol/proj';
import { diagnosticParcellesState, shouldShowSelectionDialogState, validatedAreaState } from '@/store';
import { getAreaAsHectares } from '@/utils/stringutils';

export default function ParcelleSelectionCheckDialog() {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  const [shouldShowSelectionDialog, setShouldShowSelectionDialog] = useAtom(shouldShowSelectionDialogState);

  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (shouldShowSelectionDialog) {
      setOpen(true);
    }
  }, [shouldShowSelectionDialog]);

  const propertyArea = useAtomValue(validatedAreaState);

  const setDiagnosticParcelles = useSetAtom(diagnosticParcellesState);

  const ref = useRef();

  const validatedParcelFeatures = validatedParcelLayer.getSource().getFeatures();

  const handleClose = () => {
    setOpen(false);
    setShouldShowSelectionDialog(false);
  };

  const showContactForm = () => {
    const diagnosticParcels = [];
    validatedParcelFeatures.forEach((olFeat) => {
      const feature = new GeoJSON({
        dataProjection: proj2154,
        featureProjection: proj3857,
      }).writeFeatureObject(olFeat);

      diagnosticParcels.push({
        ...feature.properties,
        geom: new WKB().writeGeometry(olFeat.getGeometry(), {
          dataProjection: proj4326,
          featureProjection: proj3857,
          decimals: 7,
        }),
      });
    });
    setOpen(false);
    setDiagnosticParcelles({
      parcelles: diagnosticParcels,
      contraintes: null,
    });
    setShouldShowSelectionDialog(false);
  };

  return (
    <div ref={ref}>
      <Dialog
        container={ref.current}
        maxWidth="md"
        fullWidth={true}
        scroll="paper"
        fullScreen={fullScreen}
        open={open}
        onClose={null}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title" color="primary">
          Synthèse de votre sélection
        </DialogTitle>
        <DialogContent dividers={true}>
          <DialogContentText>Sélection totale : {getAreaAsHectares(propertyArea)}</DialogContentText>
          <ParcelleTable parcelles={validatedParcelFeatures} />
          <DialogContentText sx={{ mt: 2 }}>
            Validez votre sélection pour accéder au formulaire de contact.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={showContactForm}>
            Valider ma sélection
          </Button>
          <Button variant="outlined" onClick={handleClose}>
            Modifier ma sélection
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

ParcelleSelectionCheckDialog.propTypes = {
  map: PropTypes.object,
};
